// extracted by mini-css-extract-plugin
module.exports = {"kv":"_2-h2zc_DRXpdNNFXJOcXD9"};